import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { BreadcrumbPartialState } from './breadcrumb.reducer';
import { BreadcrumbQuery } from './breadcrumb.selectors';
import * as BreadcrumbActions from './breadcrumb.actions';
import { ActionWithCorrelationAttributes } from '@kion/ngrx-helper';

@Injectable()
export class BreadcrumbFacade {

  breadcrumb$ = this.store.pipe(select(BreadcrumbQuery.getBreadcrumb));

  constructor(private store: Store<BreadcrumbPartialState>) { }

  protected dispatch(action, correlationId?: string): ActionWithCorrelationAttributes {
    if (correlationId) {
      action.__correlationId = correlationId;
    }
    this.store.dispatch(action);
    return action;
  }

  loadAll(pageUid: string, correlationId?: string): ActionWithCorrelationAttributes {
    return this.dispatch(BreadcrumbActions.loadAll({ pageUid: pageUid }), correlationId);
  }
}
